// scan/connect lifecycle のパラメータ。RemoteConfig を持たない spot では定数で管理する。
// platform 既定 (scan_timeout=20s / scan_tries=1) をミラー。
export const SCAN_TIMEOUT_MS = 20_000
// retry は未実装（platform も tries=1・単発scan）。実装時に再導入する。
export const BATTERY_TIMEOUT_MS = 15_000 // 0x08 独立往復の応答待ち上限

// operation result 待ちの上限。AES 経路には transport timeout が無いため usecase 側で
// hang(沈黙/malformed-only/preClosed後沈黙)を防ぐ。スタンドは内部10sで能動応答するので
// 20s は正常操作に十分な余裕。V14 は V14TimeoutController(15s)が先に発火するので冗長。
export const OPERATION_TIMEOUT_MS = 20_000

// タイムアウトの「定刻発火」判定の猶予。実経過が operationTimeoutMs + この値を超えて
// タイマが発火した場合、ランタイムが suspend されていた（=フレーム喪失の可能性）とみなす
export const RESULT_TIMEOUT_SCHEDULE_GRACE_MS = 5_000

// /ble/state POST が settle しない場合の上限(注入される HTTP client は素の fetch で
// timeout を持たない)。/ble/state は補助記録なので、超過したら warn して操作を継続する。
export const BLE_STATE_POST_TIMEOUT_MS = 10_000

// spjs ブリッジ呼び出しの settle 上限（aikasa/ikasa_platform#7706・案A: 境界の有界化）。
// ブリッジは「成功/失敗/無応答」の3値で失敗し得るため、全 await に withBridgeCap で上限を敷く。
// 値は native の写し:
//   createConnection 10s = stand_peripheral.dart の connect(timeout: 10s)
//   discoverServices/discoverCharacteristics/enableNotify/write 15s = FlutterBluePlus 既定 timeout
//   closeConnection 5s = stand_peripheral.dart の disconnect 上限
// openAdapter/closeAdapter は web 固有（spjs の adapter セッション概念）で native に対応物が
// 無いため、接続系(10s)/切断系(5s)にそれぞれ合わせる。
export const BRIDGE_TIMEOUTS_MS = {
  openAdapter: 10_000,
  closeAdapter: 5_000,
  createConnection: 10_000,
  discoverServices: 15_000,
  discoverCharacteristics: 15_000,
  enableNotify: 15_000,
  write: 15_000,
  closeConnection: 5_000,
  readRssi: 5_000, // #7709 link-alive probe。切断済みリンクでの無応答を有界に見切る
} as const
